<template>

  <div class="main">
    <header>
      <div class="text" style="float: left;">
        <h2 >评分详情</h2>
      </div>
      <div style="  clear:both;"></div>
  <div class="tag">
      <el-tag
        v-for="item in quarters"
        :key="item.id"
        :type="item.name"
        :class="{active : item.id===aquarter}"
        @click="setbat(item.id)"
        effect="light">
        {{ item.name }}
      </el-tag>
  </div>
      <div class="data">
        <el-date-picker
          v-model="ayears"
          type="year"
          format="yyyy"
          value-format="yyyy"
          @change="pickerChangeFn"
          placeholder="请选择年份">
        </el-date-picker>
      </div>
      <div style="  clear:both;"></div>
    </header>

  <div class="table-box">


          <el-table
            :data="DetailByArgllist"
            height="474"
            border
            style="width: 100%;">
            <el-table-column
              type="index"
              label="序号"
              width="100">
            </el-table-column>
            <el-table-column
              prop="scoreTypeName"
              label="指标类别"
             >
            </el-table-column>
            <el-table-column
              label="指标项与分值"
             >
              <template slot-scope="scope">
                {{scope.row.scoreItemName}}(分值：{{scope.row.scoreValue}}分)
              </template>
            </el-table-column>
            <el-table-column
              prop="itemScore"
              label="分值"
              >


            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="DetailByArgpageSize"
            :total="DetailByArgtotal"
            @current-change="setdetaigpage"

          >
          </el-pagination>


  </div>
  </div>

</template>

<script>
export default {
  name: "Operaview",
  data(){
    return{
      quarters: [
        {   id:1,
          name: '第一季度',

        },
        {   id:2,
          name: '第二季度',

        },
        {
          id:3,
          name: '第三季度',
        },
        {
          id:4,
          name: '第四季度',
        },
      ],
      DetailByArgpage:1,
      DetailByArgpageSize:10,
      DetailByArgtotal:0,
      DetailByArgllist:[],
      aquarter:'',
      ayears:'',
    }
  },
  props:["curId"],
  watch:{
    curId:function(value){
      //this.selecTopera();
    },
    ayears:function (value){
      this.selectGradeDetailByArgPage();
    }

  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{
     // vm.getGradeDet();
    });
  },
  mounted () {
    window.setTimeout(() => {
        this.selectGradeDetailByArgPage();
    }, 100);
  },
  methods:{
    pickerChangeFn(value){ // 日期选择器改变事件 ~ 解决日期选择器清空 值不清空的问题
      if(value===null){
        this.ayears = value
      }},
    setbat(index){
      this.aquarter = index;
      this.selectGradeDetailByArgPage()
    },

    selectGradeDetailByArgPage(){
      let that = this;
      let myDate = new Date();
      let years = myDate.getFullYear(); //获取当前年
      this.ayears=this.ayears||''+years;
      let mon = myDate.getMonth() + 1; //获取当前月
      let aquarters = 1
      if(mon>=1&&mon<4){
        aquarters = 1;
      }else if(mon>=4&&mon<7){
        aquarters = 2;
      }else if(mon>=7&&mon<10){
        aquarters = 3;
      }else if(mon>=10&&mon<12){
        aquarters = 4;
      }
      this.aquarter= this.aquarter || aquarters;
      let GradeDetailByArgPage = {
        operatorNum:this.curId,
        year: this.ayears,
        quarter:this.aquarter,
        page:this.DetailByArgpage,
        pageSize:this.DetailByArgpageSize,
      }
      this.$axios
        .post('/webapi/greadeDetail/selectGradeDetailByArgPage',GradeDetailByArgPage)
        .then(function (res) {
          console.log(res)
          if(res.data.code==200){
            that.DetailByArgllist = res.data.data.list;
            that.DetailByArgtotal = res.data.data.total;
          }else {
            that.$message.error(res.data.msg)
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },
    setdetaigpage(DetailByArgpage){
      this.DetailByArgpage = DetailByArgpage;
      this.selectGradeDetailByArgPage();
    },
  },


}
</script>

<style scoped>
.tag{float: left;
  line-height: 0;
}
.tag .el-tag{
   height: 40px;
  width: 113px;
  line-height: 40px;
  color: #484848;
  background: #ffffff;
  border: 0px;
  cursor: pointer;
}
.tag .el-tag:hover,.tag .el-tag.active{
  color: #ffffff;
  background: #109585;

}
.data{
  margin-top: -50px;
}
.el-table th>.cell {
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #000;
}
.el-button--mini, .el-button--mini.is-round {
  padding: 11px 19px;
  font-size: 16px;
  margin-right: 20px;
  margin: 16px;
}
.uploadIcon {
  display: block !important; /* 上传按钮隐藏 */
}
html,body,#app {
  height: 100%;
  margin: 0;
  padding: 0;
}
.el-message-box{
  width: 800px;
}
.el-table__header{
  width: 100%!important;
}
#app {

  background: rgba(0,0, 0, 0.05);
}
.el-container{
  height: 100%;
}
.el-menu{
  background: none;
  margin-top: 50px;
  border: 0px;
}
.el-menu-item{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin: 25px auto;
  height: 78px;
}
.el-menu-item:hover{
  background: #7073FF;
}
.el-menu-item.is-active {
  color: #fff;
  background: #7073FF;
}
.el-menu-item [class^=el-icon-] {
  margin-right: 0px;
  width: 34px;
  text-align: center;
  font-size: 34px;
  vertical-align: middle;
  margin-left: 0px;
}
.el-menu-item i {
  color: #fff;
}
.el-menu-item p{
  line-height: 4px;
  margin: 0px;

}
.el-header, .el-footer {
  width: 100%;
  height: 88px;
  background: #FFFFFF;
  box-shadow: -10px 10px 20px 0px rgba(30, 30, 30, 0.05);
  margin: 30px auto;
  padding: 0 60px;
}
.el-header h1{
  line-height:60px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #222222;
  float: left;
  margin: 0;
}
.el-header span{
  float: right;
  line-height: 60px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #444444;
}
.el-main {
  width: 100%;
  background-color: #fff;
  color: #333;
  text-align: center;
  padding: 0;

}
.el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
  border-color: #EDEFF5;
}
.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: #EDEFF5;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #109585;
color: #fff;
}
.el-pagination.is-background .el-pager li:hover{
  color: #fff!important;
  background-color: #109585 !important;

}
.table-box {
  margin-top: 30px;
  padding: 30px;
  background: #FFFFFF;

}
.el-table th > .cell {
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #000000;


}

.el-table .cell {
  text-align: center;

}
.el-table thead tr{
  background: none;

  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
}
.el-avatar{
  margin-top:54px;
  width: 64px;
  height: 64px;
  border: 2px solid #FFFFFF;
  border-radius: 50%;

}
.el-aside {
  background-color: #3E4356;
  color: #FFFFFF;
  text-align: center;
  box-shadow: 3px 0px 8px 0px rgba(62, 67, 86, 0.26);
}

.el-table .el-button--success{

  background: #109585;
  border-radius: 4px;
  border-color: #109585;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 100%;
}
.el-pagination{
  padding: 16px 5px;
}
.el-menu-item{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin: 25px auto;
  height: 78px;
  padding-right: 8px!important;
  padding-left: 8px!important;
  padding-bottom: 20px!important;
}
</style>



// WEBPACK FOOTER //
// src/view/Operaview.vue